import {
    allFetch
} from "../Domain";

/**
 * @description PDI流程
 */
export const PDIProcedureKT = (() => {

    // KT特區

    /**
     * @description 新增PDI流程工作站
     * @param {string} pdi_pm_id PDI流程主項流水號
     * @param {string} pdi_ws_id 工作站流水號
     * @param {string} pdi_ws_name 工作站名稱
     * @param {string} appointment_time 預約時間
     * @param {string} note 備註
     * @param {string} seq 排序
     * @returns res
     */
    const PDIProcedureWorkstationCreateKT = async function (obj = {
        pdi_pm_id: '',
        pdi_ws_id: '',
        pdi_ws_name: '',
        appointment_time: '',
        note: '',
        seq: ''
    }) {
        return await allFetch('PDIProcedureKT/PDIProcedureWorkstationCreateKT', obj);
    }

    /**
     * @description 修改PDI流程工作站
     * @param {string} pdi_pm_id PDI流程主項流水號
     * @param {string} appointment_time 預約時間
     * @param {string} note 備註
     * @param {string} seq 排序
     * @returns res
     */
    const PDIProcedureWorkstationUpdateKT = async function (obj = {
        pdi_pw_id: '',
        appointment_time: '',
        note: '',
        seq: ''
    }) {
        return await allFetch('PDIProcedureKT/PDIProcedureWorkstationUpdateKT', obj);
    }

    /**
     * @description PDI流程工作站完成
     * @param {string} pdi_pw_id PDI流程工作站流水號
     * @returns res
     */
    const PDIProcedureWorkstationFinishKT = async function (obj = {
        pdi_pw_id: '',
    }) {
        return await allFetch('PDIProcedureKT/PDIProcedureWorkstationFinishKT', obj);
    }

    /**
     * @description 刪除PDI流程工作站
     * @param {string} pdi_pw_id PDI流程工作站流水號
     * @returns res
     */
    const PDIProcedureWorkstationDeleteKT = async function (obj = {
        pdi_pw_id: '',
    }) {
        return await allFetch('PDIProcedureKT/PDIProcedureWorkstationDeleteKT', obj);
    }

    /**
     * @description PDI工作站送審
     * @param {string} pdi_pm_id PDI流程主項流水號
     * @returns res
     */
    const PDIProcedureMasterWorkstationSubmitKT = async function (obj = {
        pdi_pm_id: '',
    }) {
        return await allFetch('PDIProcedureKT/PDIProcedureMasterWorkstationSubmitKT', obj);
    }

    /**
     * @description 審核PDI工作站
     * @param {string} pdi_pm_id PDI流程主項流水號
     * @param {string} status 審核狀態
     * @param {string} note 備註
     * @returns res
     */
    const PDIProcedureMasterWorkstationAuditKT = async function (obj = {
        pdi_pm_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('PDIProcedureKT/PDIProcedureMasterWorkstationAuditKT', obj);
    }


    return {
        PDIProcedureWorkstationCreateKT,
        PDIProcedureWorkstationUpdateKT,
        PDIProcedureWorkstationFinishKT,
        PDIProcedureWorkstationDeleteKT,
        PDIProcedureMasterWorkstationSubmitKT,
        PDIProcedureMasterWorkstationAuditKT,
    };
})()